import axios from 'axios';

// const baseURL = 'https://markerz.eu.ngrok.io';
const baseURL = 'http://localhost:4000';

const axiosInstance = axios.create({
    baseURL,
});

const apiService = {
    calculateTrip: ({ origin, destination, date, nbPassengers }) => {
        return axiosInstance.post('/trip/calculate', {
            origin,
            destination,
            date, 
            nbPassengers
        })
        .then((response) => {
            return response.data;
        });
    }
};

export default apiService;